// extracted by mini-css-extract-plugin
export default {"P":"login_P__X8SQV","Title":"login_Title__kBe6j","FormWrapper":"login_FormWrapper__eb8lz"};